import React from 'react';
import AboutUs from './Aboutus/aboutus';
import Footer from './Footer/footer';
import Gallery from './Gallery/gallery';
import Hero from './Hero/hero';
import Marquee from './Marquee/banner';
import Service from './Service/service';
import Sponsers from './Sponsers/sponsers';
import FloatingNavbar from './Navbar/floating_navbar';


const Home = () => {
  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 90,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>

      <FloatingNavbar handleScrollToSection={handleScrollToSection} visibleItems={['home', 'about', 'services', 'gallery', 'sponsors', 'contact' , 'language']} />
      <Marquee />
      <div id="home"><Hero /></div>
      <div id="about"><AboutUs /></div>
      <div id="services"><Service /></div>
      <div id="gallery"><Gallery /></div>
      <div id="sponsors"><Sponsers /></div>
      <div id="contact"><Footer /></div>
    </>
  );
};

export default Home;
